module.exports = __webpack_public_path__ + "static/media/charging-light-idea.b72e16e4.svg";